import { render, staticRenderFns } from "./RestaurantForm.vue?vue&type=template&id=81c27bb6&"
import script from "./RestaurantForm.vue?vue&type=script&lang=js&"
export * from "./RestaurantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RestaurantForm.vue"
export default component.exports